import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getSession } from '../store/action/lessons';


const AdminProtection = ({ children }) => {
  const userInfo = JSON.parse(localStorage.getItem('lesson_session')) ?? null
  
  if (userInfo?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
return children ;
};


const ProtectedRoute = ({ children }) => {
  const [isSessionValid, setIsSessionValid] = useState(null);

  useEffect(() => {
    const checkSession = async () => {
      const sessionAvailable = await getSession();
      setIsSessionValid(sessionAvailable);
    };
    checkSession();
  }, []);

  if (isSessionValid === null) {
    return <div>Loading...</div>; // or any other loading indicator
  }
  return isSessionValid ? children : <Navigate to="/signin" replace />;
};

export { ProtectedRoute, AdminProtection };
